import {GlobalGeist, GlobalThemeStyle} from '@dagster-io/ui-components';

export default function ThemedPage({children}: {children: React.ReactNode}) {
  return (
    <>
      <GlobalThemeStyle />
      <GlobalGeist />
      <div style={{width: '100%'}}>{children}</div>
    </>
  );
}
